import { api } from './client'
import type { AllocationResult } from '@/lib/allocation'

export function fetchAllocation(windowDays: number): Promise<AllocationResult> {
  return api.get(`/api/allocation?windowDays=${windowDays}`)
}

export function fetchCalendarAllocation(from: string, to: string): Promise<AllocationResult> {
  return api.get(`/api/allocation/calendar?from=${from}&to=${to}`)
}
